import { defineKind } from "./base";

/**
 * Any other provider room-stc resolved, in the hosted player (spec: "unknown provider → hosted-player embed"; the
 * server only stores providers it resolved). Also the registry's default.
 */
export const embed = defineKind({
  id: "embed",
  types: [],
  surface: "embed",
  icon: "link",
  caps: { seekable: true, endsByItself: true, heldWhenHidden: true, dockable: true, fullScreen: true },
  label: (t) => t("player_kind_link", "Link"),
});
